import React from "react";

const Header = () => {
  return (
    <nav className="navbar navbar-horizontal navbar-expand-lg navbar-dark bg-default text-center p-1 pt-2">
      <h1
        className="display-2 text-center w-100 m-0"
        style={{ color: "#e1e1e1" }}
      >
        Microlessons - Learn Something New in a Minute
      </h1>
    </nav>
  );
};

export default Header;
